// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true,"publicPath":"../../"}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-276f1b9c","scoped":false,"hasInlineConfig":false}!./~/stylus-loader?{"sourceMap":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/OffCanvas/OffCanvas.vue
// module id = 525
// module chunks = 2